module.exports = __webpack_public_path__ + "img/result_report.75878548.png";